import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  // fonts: {
  //   heading: 'Trade Gothic LT',
  //   body: 'Trade Gothic LT',
  // },

  breakpoints: {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em",
    "3xl": "120em",
  },

  colors: {
    red: {
      "50": "#ffe8e9",
      "100": "#f1c3c4",
      "200": "#e39ca0",
      "300": "#d6757e",
      "400": "#c94f52",
      "500": "#b03c36",
      "600": "#8a3329",
      "700": "#63271c",
      "800": "#3d1b10",
      "900": "#1c0a02",
    },
    teal: {
      "50": "#e0fbf9",
      "100": "#c1ece8",
      "200": "#9eded8",
      "300": "#7ad1c8",
      "400": "#57c4b8",
      "500": "#3fab9e",
      "600": "#2e857b",
      "700": "#1e5f58",
      "800": "#0b3a35",
      "900": "#001513",
    },
    beige: {
      "50": "#f9f6e8",
      "100": "#f9f6e8",
      "200": "#dbcca6",
      "300": "#ccb382",
      "400": "#be975f",
      "500": "#a57746",
      "600": "#805736",
      "700": "#5c3a26",
      "800": "#372015",
      "900": "#130600",
    },
    blue: {
      "50": "#e7f3fe",
      "100": "#c4d8ed",
      "200": "#a0bfde",
      "300": "#7ba5d1",
      "400": "#578bc4",
      "500": "#3e71ab",
      "600": "#305884",
      "700": "#213f60",
      "800": "#12263a",
      "900": "#020d18",
    },
    lightGray: {
      "50": "#768178",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "normal",
        minHeight: "48px",
        textTransform: "uppercase",
        _hover: { bg: "#09170D", textDecoration: "none", color: "#FFFFFF" },
      },

      variants: {
        solid: {
          bg: "#D9A542",
          fontSize: "18px",
          p: "0px 24px",
          borderRadius: "0px",
          fontWeight: "600",
          textTransform: "uppercase",
          _hover: { bg: "#09170D", textDecoration: "none", color: "#FFFFFF" },
        },
        ghost: {
          bg: "transparent",
          fontSize: "18px",
          p: "0px 24px",
          color: "#D9A542",
          borderRadius: "none",
          fontWeight: "600",
          textTransform: "uppercase",
          _hover: { bg: "#09170D", textDecoration: "none", color: "#FFFFFF" },
        },
      },
    },
  },
});

export default theme;
